// Formatea un valor (string u number, con o sin símbolos) como moneda
// mexicana — usado por las tarjetas de "Mis cotizaciones" y "Mis
// arrendamientos".
export const formatCurrency = (value: string | number): string => {
  const numericValue =
    typeof value === 'number'
      ? value
      : parseFloat(value.replace(/[^0-9.-]+/g, ''))

  if (isNaN(numericValue)) return String(value)

  return new Intl.NumberFormat('es-MX', {
    style: 'currency',
    currency: 'MXN',
  }).format(numericValue)
}
